import {
  NgModule
} from "@angular/core";
import {
  CommonModule
} from "@angular/common";

import {
  Routes,
  RouterModule
} from '@angular/router';

import {
  DGXXMLRequestValidateComponent
} from './components/dgx-xml-request-validate/dgx-xml-request-validate.component';
import {
  DGXHTMLResponseComponent
} from './components/dgx-html-response/dgx-html-response.component';
import {
  DGXXMLResponseComponent
} from './components/dgx-xml-response/dgx-xml-response.component';
import {
  MauiFooterComponent
} from './components/layout/maui-footer/maui-footer.component';
import {
  DialogBoxComponent
} from "./components/dialog-box/dialog-box.component"
import {
  FormCommonFieldsComponent
} from './components/form-common-fields/form-common-fields.component';
import {
  ModalModule
} from 'ngx-bootstrap/modal';
import {
  SidebarComponent
} from './components/layout/sidebar/sidebar.component';
import {
  RightBoxComponent
} from './components/layout/right-box/right-box.component';
import { ReactiveFormsModule } from "@angular/forms";




@NgModule({
  declarations: [
    FormCommonFieldsComponent,
    DialogBoxComponent,
    DGXXMLRequestValidateComponent,
    DGXHTMLResponseComponent,
    DGXXMLResponseComponent,
    RightBoxComponent,
    MauiFooterComponent,
    SidebarComponent,
  ],
  imports: [CommonModule, ReactiveFormsModule, RouterModule,
    ModalModule],
  exports: [
    FormCommonFieldsComponent,
    DialogBoxComponent,
    DGXXMLRequestValidateComponent,
    DGXHTMLResponseComponent,
    DGXXMLResponseComponent,
    RightBoxComponent,
    MauiFooterComponent,
    SidebarComponent
  ],

 
})
export class SharedModule {}
